// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100%;
  font-size: 1.2rem;
  line-height: 1.4rem;
  text-align: right;
  color: var(--black);
  white-space: nowrap;
  padding: 1.7rem 1.2rem;
  border-bottom: 0.1rem solid rgba(225, 227, 235, 0.7);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
:host.title {
  font-size: 1.6rem;
  line-height: 1.9rem;
  font-weight: 500;
  white-space: nowrap;
  border: 0;
  justify-content: flex-start;
  grid-column: 1/1;
  position: sticky;
  left: 0;
}
:host.indicator {
  text-align: left;
  white-space: normal;
  background: var(--white);
  border-right: 0.1rem solid rgba(225, 227, 235, 0.7);
  grid-column-start: 1;
  justify-content: flex-start;
  position: sticky;
  left: 0;
}
:host.header {
  font-size: 1.1rem;
  line-height: 1.3rem;
  background: var(--table-header);
}
:host.header.indicator {
  text-transform: uppercase;
}
:host.main {
  background: var(--bg);
}
:host.border-top {
  border-top: 0.1rem solid rgba(225, 227, 235, 0.7);
}`, "",{"version":3,"sources":["webpack://./src/shared/tables/cell/cell.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oDAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AACF;AACE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;AACJ;AAEE;EACE,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,mDAAA;EACA,oBAAA;EACA,2BAAA;EACA,gBAAA;EACA,OAAA;AAAJ;AAGE;EACE,iBAAA;EACA,mBAAA;EACA,+BAAA;AADJ;AAGI;EACE,yBAAA;AADN;AAKE;EACE,qBAAA;AAHJ;AAME;EACE,iDAAA;AAJJ","sourcesContent":[":host {\n  height: 100%;\n  font-size: 1.2rem;\n  line-height: 1.4rem;\n  text-align: right;\n  color: var(--black);\n  white-space: nowrap;\n  padding: 1.7rem 1.2rem;\n  border-bottom: 0.1rem solid rgba(225, 227, 235, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  &.title {\n    font-size: 1.6rem;\n    line-height: 1.9rem;\n    font-weight: 500;\n    white-space: nowrap;\n    border: 0;\n    justify-content: flex-start;\n    grid-column: 1/1;\n    position: sticky;\n    left: 0;\n  }\n\n  &.indicator {\n    text-align: left;\n    white-space: normal;\n    background: var(--white);\n    border-right: 0.1rem solid rgba(225, 227, 235, 0.7);\n    grid-column-start: 1;\n    justify-content: flex-start;\n    position: sticky;\n    left: 0;\n  }\n\n  &.header {\n    font-size: 1.1rem;\n    line-height: 1.3rem;\n    background: var(--table-header);\n\n    &.indicator {\n      text-transform: uppercase;\n    }\n  }\n\n  &.main {\n    background: var(--bg);\n  }\n\n  &.border-top {\n    border-top: 0.1rem solid rgba(225, 227, 235, 0.7);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
